export default "__VITE_ASSET__ZXpOX8wJ__"